import { Component, Log, CacheStorage } from '@WidgetWorks';

export default class UploadWindowButton extends Component {
    constructor(appConfig) {
        super(appConfig);
        this.interacted = false;

        // Button requires a connection / open app.
        // This will be populated from the appRunner.
        // as the appRunner will dictate, what app this button will
        // open.
        // TODO: Abstract out a button.
        this.appToDisplay = null;
    }

    async overrideHook() {}

    preRenderHook() {}

    beforeMountHook() {
        this.root = this.element.querySelector('div');
        return true;
    }

    postElementMount() {}

    postRenderHook() {
        return true;
    }

    firstClickAnalytics() {
        const firstClickedFlag = CacheStorage.get('PRIME_AI_STYLESNAP_APP_FIRST_CLICKED_BUTTON');
        if (firstClickedFlag) return false;
        this.analytics.registerEvent('button_clickfirsttime', 1, 'StyleSnap');
        CacheStorage.set('PRIME_AI_STYLESNAP_APP_FIRST_CLICKED_BUTTON', true, CacheStorage.expirationEndOfDay());
        return true;
    }

    firstInteractionHook() {
        if (this.interacted) return false;
        this.interacted = true;
        console.log(...Log.w(this.constructor.name, 'LOG', 'First Interaction'));
        this.firstClickAnalytics();
        return true;
    }

    async init() {
        console.log(...Log.w(this.constructor.name, 'LOG', 'Initialising...'));

        // This hook will run the custom function defined in the override itself.
        await this.overrideHook();

        // Before rendering, do these things.
        this.preRenderHook();

        // Insert CSS into virtual element
        // this.insertCSS(this.styles);

        // Insert HTML into virtual element
        this.insertHTML(this.markup);

        // Update HTML with Languages into the virtual element
        // this.insertLanguages(this.language);

        // Run the pre mounted hook.
        this.beforeMountHook();

        // Once the mount point is available, create copies
        // and mount it.
        await this.mountElements();

        // Now mounted, run the post hooks
        this.postRenderHook();

        console.log(...Log.w(this.constructor.name, 'LOG', 'Initialised'));
    }

    insertHTML(markupFiles, insertionPoint = null) {
        const parser = new DOMParser();

        for (const htmlText of markupFiles) {
            const parsedHTML = parser.parseFromString(htmlText, 'text/html');

            if (insertionPoint) {
                const targetElement = this.element.querySelector(insertionPoint);
                if (targetElement) {
                    // Append each element from parsedHTML to the shadow DOM
                    parsedHTML.body.childNodes.forEach((node) => {
                        this.element.appendChild(node.cloneNode(true));
                    });
                }
            } else {
                // If no insertion point specified, simply append the HTML elements to the shadow DOM
                parsedHTML.body.childNodes.forEach((node) => {
                    this.element.appendChild(node.cloneNode(true));
                });
            }
        }
    }

    async mountElements() {
        // use the standard one.
        const result = await this.mountComponentToPoints();
        return result;
    }

    createEventListeners(elements) {
        for (const element of elements) {
            const elm = this.getElementRoot(element);
            // Sometimes, an element might have the onclick event
            // already baked into the element, in that case, we don't
            // want to add another one.
            if (!elm.onclick) {
                elm.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.openRecommendationWindow(event);
                });
            }
        }
    }

    topLevelClickAnalytics() {
        this.analytics.registerEvent('button_click', 1, 'VisualSearchParentApp');

        // Check if the user is unique.
        const flagExists = CacheStorage.get('PRIME_AI_VISUAL_SEARCH_FIRST_CLICKED_BUTTON');

        // If the user is unique, register a unique visitor event.
        // and set a flag to say they are no longer unique.
        if (!flagExists) {
            this.analytics.registerEvent('button_clickfirsttime', 1, 'VisualSearchParentApp');
            CacheStorage.set('PRIME_AI_VISUAL_SEARCH_FIRST_CLICKED_BUTTON', true, CacheStorage.expirationEndOfDay());
        }
    }

    openRecommendationWindow(event) {
        // !!!!! Parse the arguments from the elem.

        // Analytics for someone has clicked the button
        // TODO: Needs a new analytics event as we need to define all the buttons.
        // TODO: in this case it's the upload button on the search bar, not PDP.
        this.analytics.registerEvent('button_click', 1, 'StyleSnap');
        this.topLevelClickAnalytics();

        // Set into localstorage.
        this.firstInteractionHook();

        // Arguments from the parent can be used in the internal app.
        // So here we extract all the arguments from the parent.
        // Given these argument we decide what behaviour is expected.
        // For example, we can pass a image_url and instead of making the user
        // upload an image, it downloads the one from the given url.
        // Although this app, will only forward these details to the appToDisplay.
        // The external app is expected to have this.
        // !! Abstract this into it's own class. we have repeated this logic to much.
        this.appToDisplay.openApp(event.currentTarget);
    }
}
